import { render, staticRenderFns } from "./DocumentLayoutList.vue?vue&type=template&id=a53208f4"
import script from "./DocumentLayoutList.vue?vue&type=script&lang=js"
export * from "./DocumentLayoutList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports